import { Page } from 'zens-storybook'
import { PropsWithChildren, Suspense } from 'react'
import { useNumberParams, usePathname } from 'zens-router'
import { useMenu } from '@dms/hook'

type Props = object

const PageLayout = (props: PropsWithChildren<Props>) => {
  const [{ companyId }] = useNumberParams()
  const menu = useMenu({ companyId })
  const pathname = usePathname()
  const hideMenu = /\/assistant\/guide$/.test(pathname)

  return (
    <Page menu={hideMenu ? undefined : menu} brandingIdentityHref={`/companies/${companyId}`}>
      <Suspense fallback={null}>{props.children}</Suspense>
    </Page>
  )
}

export default PageLayout
